module.exports = __webpack_public_path__ + "img/FONDOPANTGDL01.8d1c4ebc.png";